import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RAGBreakdown } from 'src/app/modules/shared/models/rag/ragBreakdown';
import { RAGStatus } from '../../../models/rag/ragStatus';
import { T } from 'src/assets/i18n/translation-keys';

@Component({
    selector: 'app-summary-bar',
    templateUrl: './summary-bar.component.html',
    styleUrls: ['./summary-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SummaryBarComponent {
  @Input() label: string;
  @Input() message: string;
  @Input() showRagBreakdown: boolean;
  @Input() ragBreakdowns: RAGBreakdown[];
  @Input() messageColor: string;

  @Output() onRAGsFiltered: EventEmitter<RAGStatus[]> = new EventEmitter<RAGStatus[]>();

  public filteredRags: RAGStatus[] = [];
  public T = T;

  trackByMethod(index: number, el: RAGBreakdown): RAGStatus {
    return el.ragStatus;
  }

  calculateRelativeWidth(value: number): number {
    return Math.round((value / this.ragBreakdowns.reduce((prev, curr) => prev + curr.count, 0)) * 100);
  }
}
